(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/tracking.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/tracking.js');
"use strict";

const {
  trackEvent
} = svs.components.analytics;
setGlobal('svs.lyckoplatsen.shared_result', {
  trackOnShowDirect: _ref => {
    let {
      channel,
      isPrimary,
      win
    } = _ref;
    trackEvent({
      category: 'result-lyckoplatsen',
      action: 'click-show-direct',
      opt_label: "".concat(isPrimary ? 'primary' : 'secondary', "_").concat(channel),
      opt_value: win
    });
  },
  trackOnClickStartDraw: () => {
    svs.components.analytics.trackEvent({
      category: 'Lyckoplatsen',
      action: 'Rättning',
      opt_label: 'Starta dragning'
    });
  }
});

 })(window);